import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { Style } from './style';
import Widget from '../../widget';
import Assesment from './assessment';
import AssessmentTrend from './assessmentTrend';
import ItemToFocus from '../../components/itemToFocust';
import { AnalysisService } from '../../../../../services';
import InformationAvailability from '../../components/informationAvailability';

const _default = {
  completion: {},
  challenges: 0,
  sources: 0,
  performanceAssessment: [],
};

const ParticipantAnalysis = ({
  data: options = [],
  selectedProject,
  showData,
}) => {
  const { t } = useTranslation();
  const [activeParticipant, setActiveParticipant] = useState(null);
  const [data, setData] = useState(_default);
  const [loading, setLoading] = useState(false);

  const _fetch = async () => {
    setLoading(true);
    try {
      const data = await AnalysisService.getAnalysis(activeParticipant, { project: selectedProject });
      if (data.data) {
        setData({
          completion: data.data?.widgets?.progressPerTime?.publishments || [],
          challenges: (data.data?.challenges || []).reduce((all, item) => {
            return all + (item.checks || []).length;
          }, 0),
          sources:
            (data?.data?.sources?.featuredData || []).length
            + (data?.data?.sources?.otherInformationSources || []).length
            + (data?.data?.sources?.supplyChainActor
              || []).length,
          performanceAssessment: data.data.widgets?.performanceAssessment,
          kycScore: typeof data.data.kycScore === 'number' ?
              Number(data.data.kycScore).toFixed(2)
              : '-',
          counterpartyScore: data.data.counterpartyScore,
          riskRediness: data.data.riskRediness,
          documentation: data.data.documentation,
          challanges: [...(data.data?.checks || []), ...(data.data?.documentationChecks || [])]
            .filter((ch) => ch && ch.challenge && ch.challengeCategory).length || 0,
        })
      }
    } catch (err) {
      console.log(err)
    }

    setLoading(false);
  };

  useEffect(() => {
    if (activeParticipant) {
      _fetch();
    }
  }, [activeParticipant]);

  useEffect(() => {
    if (options.length && !activeParticipant) {
      setActiveParticipant(options[0].datastakeId)
    }
  }, [options]);

  useEffect(() => {
    if (data && data.pariticpants && data.pariticpants[0]) {
      setActiveParticipant(data.pariticpants[0].datastakeId);
    }
  }, [data]);

  return (
    <Widget title={t('Supply Chain Participants')} className="no-px-body">
      {loading && <WidgetLoader background='rgba(255, 255, 255, 0.8)' />}
      <Style className="analysis-container" >
        {(showData) ? (
          <>
            <ItemToFocus
              selectedItem={activeParticipant}
              items={options}
              t={t}
              type="scp"
              label="Stakeholder"
              source="/assets/images/dashboard/select-icons/supply-chain-actors.svg"
              onChange={(val) => {
                setActiveParticipant(val);
              }}
            />
            <div className="info">
              <div className="info-row">
                <div className="label">
                  <p>{t('Risk Readiness')}</p>
                </div>
                <div className="value tag medium">
                  <p>
                    {data?.riskRediness || 0}%
                  </p>
                </div>
              </div>

              <div className="info-row">
                <div className="label">
                  <p>{t('Information Sources')}</p>
                </div>
                <div className="value">
                  <p>{data?.sources || 0}</p>
                </div>
              </div>

              <div className="info-row">
                <div className="label">
                  <p>{t('Documentation')}</p>
                </div>
                <div className="value">
                  <p>
                    {data?.documentation || 0}%
                  </p>
                </div>
              </div>

              <div className="info-row">
                <div className="label">
                  {/* <p>{t('Counterparty Rating')}</p> */}
                  <p>{t('KYC Score')}</p>
                </div>
                <div className="value">
                  <p>
                    {data?.kycScore || 0}
                  </p>
                </div>
              </div>

              <div className="info-row">
                <div className="label">
                  <p>{t('Challenges Identified')}</p>
                </div>
                <div className="value">
                  <p>{data?.challanges || 0}</p>
                </div>
              </div>

            </div>
            <div>
              <div className="widget-item w-p">
                <Assesment
                  t={t}
                  data={data?.counterpartyScore || 0}
                />
              </div>
              <div className="widget-item">
                <AssessmentTrend
                  t={t}
                  data={data.performanceAssessment}
                />
              </div>
            </div>
            {data?.completion && (
              <InformationAvailability
                t={t}
                completion={data.completion}
              />
            )}
          </>
        ) : null}
      </Style>
    </Widget>
  )
};

export default ParticipantAnalysis;
